import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { EscalationStatus } from '@shs-digi-care-monorepo/interfaces';
import { ActionRequiredDialogResult, ActionRequiredDialogData } from './action-required-dialog.model';

@Component({
    selector: 'app-action-required-dialog',
    templateUrl: './action-required-dialog.component.html',
    imports: [TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ActionRequiredDialogComponent {
    private readonly dialogRef = inject(MatDialogRef<ActionRequiredDialogComponent, ActionRequiredDialogResult>);
    private readonly router = inject(Router);
    public readonly data = inject<ActionRequiredDialogData>(MAT_DIALOG_DATA);

    protected EscalationStatus = EscalationStatus;

    protected onTakeAction(): void {
        this.dialogRef.close();
        this.router.navigate([`/request/${this.data.requestId}`]);
    }

    protected onRemindMeLater(): void {
        this.dialogRef.close({ escalationId: this.data.escalationId });
    }
}
